import { getTutorialName, HelpGuideSummary, TUTORIAL_TYPE } from "../../common/help-model"

// the help guides, opened in the help library, and the tutorials
export const constructHelp = (guides:HelpGuideSummary[]) => {
    const help = guides.map(g => {
        return {
            _key: g.slug,
            icon: "menu_book",
            // the topic is what's looked for, so it's the name
            name: g.title,
            description: "Help guide"
        }
    })

    Object.values(TUTORIAL_TYPE).forEach(t => {
        help.push({
            _key: t,
            icon: "school",
            name: getTutorialName(t),
            description: "Tutorial"
        })
    })

    return help
}

export const constructShortCuts = () => {
    return [
        {
            _key: "SELECTION",
            name: "Lasso selection",
            description: "Hold the left mouse button and drag the cursor to draw a shape around items."
        },
        {
            _key: "PAN_GRAPH",
            name: "Pan graph",
            description: "Hold the left mouse button and ALT on your keyboard while moving the cursor to move the model."
        },
        {
            _key: "ZOOM",
            name: "Zoom in and out",
            description: "Scroll the mouse wheel"
        },
        {
            _key: "PAN_UP_DOWN",
            name: "Pan up and down",
            description: "Hold CTRL while scrolling the mouse wheel"
        },
        {
            _key: "CREATE_NODE_PALETTE",
            name: "Create a new node",
            description: "Drag a node from the palette onto the canvas."
        },
        {
            _key: "NODE_PROPERTIES",
            name: "Show/edit node properties",
            description: "Select node and the properties are shown in Properties Panel on the left."
        },
        {
            _key: "NODE_PROPERTIES_DIALOG",
            name: "Show/edit node properties in dialog",
            description: "Double click a node and the properties are shown in a popup dialog box."
        },
        {
            _key: "NODE_CONTEXT_MENU",
            name: "Display context menu for node",
            description: "Right click on a node"
        },
        {
            _key: "CANVAS_CONTEXT_MENU",
            name: "Display context menu for canvas",
            description: "Right click on canvas"
        },        
        {
            _key: "INSERT_SUPPLY_CHAIN_CLICK",
            name: "Insert nodes into a supply chain",
            description: "Double click on an edge between 2 nodes to insert new action and information nodes."
        },
        {
            _key: "INSERT_SUPPLY_CHAIN_DROP",
            name: "Insert nodes into a supply chain",
            description: "Drag and drop an action or information node onto an edge to insert an action and information node into the process."
        },
        {
            _key: "CREATE_INSTANCE",
            name: "Create a duplicate role or system",
            description: "Drag an edge from an existing role or system to duplicate that node against an action or information node."
        },
        {
            _key: "CREATE_SUPPLY_CHAIN",
            name: "Create your model",
            description: "Drag an edge from an action or information node and left click on the canvas creates the next node in supply chain."
        },
        {
            _key: "CREATE_SYSTEM_INFORMATION",
            name: "Create information against a system",
            description: "Drag an edge from a system node and left click on canvas to create a new information node."
        },
        {
            _key: "CREATE_ROLE_ACTION",
            name: "Create action for a role",
            description: "Drag an edge from a role and left click on the canvas to create a new action node."
        },
        {
            _key: "EDIT_NAME",
            name: "Edit a node's name",
            description: "Select the node without a name and start typing. Edit an existing name in the node properties panel."
        },
        {
            _key: "FIND_NODE",
            name: "Search for a node",
            description: "Type the name of the node in the search bar, or find in node table in the insights. Clickng a node in search or the table will select it in model."
        }
    ]
}
